import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { CoveragePeriod } from '@/modules/UseMyMoney/UseMyMoney.types';

interface Props {
  testId?: string;
  coveragePeriods?: CoveragePeriod[];
}

const CoveragePeriodsValue: React.FC<Props> = ({ testId, coveragePeriods }) => {
  const { t } = useTranslation();

  return (
    <Box data-testId={`${testId}_coverage-periods-value_wrapper`}>
      {coveragePeriods?.map((coveragePeriod) => (
        <Text key={`${coveragePeriod?.coverageDateStart}_${coveragePeriod?.coverageDateEnd}`}>
          {coveragePeriod?.coverageDateStart
            ? dayjs(coveragePeriod?.coverageDateStart).format(DEFAULT_DATE_FORMAT) 
            : t('No start date')}
          {' - '}
          {coveragePeriod?.coverageDateEnd 
            ? dayjs(coveragePeriod?.coverageDateEnd).format(DEFAULT_DATE_FORMAT) 
            : t('No deadline')}
        </Text>
      ))}
    </Box>
  );
};

export default CoveragePeriodsValue;
